// Backend contract — see COORDINATION.md §4 (owned by C; RECONCILED & live-confirmed [C 15:36/15:41]).
//
// TWO roots:
//  • DATA  → native auto-schema CRUD (always-on, live-confirmed): schemaBase + /<collection>/<op>.
//  • AUTH  → the ONE custom API the SPA calls (Admin Login): customApiBase + /admin-login.
// Both derive from apiBaseUrl + sitePath, so there's a single place to change each.
export const environment = {
  production: false,
  // API Maker REST host — CONFIRMED live (note `.be.`).
  apiBaseUrl: 'https://rr.dev.be.savaapi.com',
  // Native schema-CRUD URL segments: /api/schema/{sitePath}/{apiInstance}/{apiDatabase}/<collection>/<op>.
  apiInstance: 'mongodb',
  apiDatabase: 'mmtess',
  // user-path / adminUserPath (first segment after /api/schema AND the /api/custom-api segment).
  sitePath: 'mmtess',
  // Optional API secret id (x-am-secret) — leave empty unless the backend asks for it.
  apiSecret: '',
  // Public base for S3-key image refs (uploadPath that is a key, not a full URL). Set to the
  // bucket/CDN origin, e.g. 'https://my-bucket.s3.ap-south-1.amazonaws.com' or a CloudFront URL.
  // Leave '' if all images are full URLs (seed/legacy) — those resolve without it. Freshly
  // uploaded images also preview via the URL returned by Upload Image, so this is only needed to
  // re-display previously-uploaded S3-key images when editing.
  s3PublicBaseUrl: 'https://sava-s3.in-maa-1.linodeobjects.com',
  // Dev-only fallback AM token; real tokens come from AuthService.login().
  devAuthToken: '',

  // DATA root — native auto-schema CRUD (LIVE per C [15:36]). Append `/<collection>/<op>`
  // (ops: /query, /get-by-id/{id}, /save-single-or-multiple, /update-by-id/{id}, DELETE /{id}).
  get schemaBase(): string {
    return `${this.apiBaseUrl}/api/schema/${this.sitePath}/${this.apiInstance}/${this.apiDatabase}`;
  },
  // AUTH root — custom APIs (per C [15:41]: /api/custom-api/{userPath}). Only Admin Login is here now.
  get customApiBase(): string {
    return `${this.apiBaseUrl}/api/custom-api/${this.sitePath}`;
  },
};
